module.exports = __webpack_public_path__ + "img/appAsset--email-ax.555eaba0.svg";